export default __webpack_public_path__ + "static/dubai_map-d9e68baa8bcdbc5d52841aff8ac02e64.svg";